/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 - http://www.apache.org/licenses/LICENSE-2.0
 */
"use strict";
/**
 * The four basic intents.
 */
(function (Intent) {
    Intent[Intent["PRIMARY"] = 0] = "PRIMARY";
    Intent[Intent["SUCCESS"] = 1] = "SUCCESS";
    Intent[Intent["WARNING"] = 2] = "WARNING";
    Intent[Intent["DANGER"] = 3] = "DANGER";
})(exports.Intent || (exports.Intent = {}));
var Intent = exports.Intent;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9jb21tb24vaW50ZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7R0FHRzs7QUFFSDs7R0FFRztBQUNILFdBQVksTUFBTTtJQUNkLHlDQUFPLENBQUE7SUFDUCx5Q0FBTyxDQUFBO0lBQ1AseUNBQU8sQ0FBQTtJQUNQLHVDQUFNLENBQUE7QUFDVixDQUFDLEVBTFcsY0FBTSxLQUFOLGNBQU0sUUFLakI7QUFMRCxJQUFZLE1BQU0sR0FBTixjQUtYLENBQUEiLCJmaWxlIjoiY29tbW9uL2ludGVudC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qXG4gKiBDb3B5cmlnaHQgMjAxNSBQYWxhbnRpciBUZWNobm9sb2dpZXMsIEluYy4gQWxsIHJpZ2h0cyByZXNlcnZlZC5cbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgLSBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqL1xuXG4vKipcbiAqIFRoZSBmb3VyIGJhc2ljIGludGVudHMuXG4gKi9cbmV4cG9ydCBlbnVtIEludGVudCB7XG4gICAgUFJJTUFSWSxcbiAgICBTVUNDRVNTLFxuICAgIFdBUk5JTkcsXG4gICAgREFOR0VSXG59XG4iXSwic291cmNlUm9vdCI6Ii9zb3VyY2UvIn0=



/*****************
 ** WEBPACK FOOTER
 ** ./~/@blueprintjs/core/dist/common/intent.js
 ** module id = 194
 ** module chunks = 0
 **/